import { useContext, useEffect, useState } from "react";

import {
  Button,
  Grid,
  Tooltip,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import { Add, CheckCircleOutline, HighlightOff } from "@material-ui/icons";

import { useHistory } from "react-router-dom";

import SearchInput from "../../components/basics/SearchInput";
import TableDefault from "../../components/grid/TableDefault";
import {
  updateCliente,
  findCliente,
} from "../../repository/ERP/prouser/ClienteService";
import useClienteController from "./ClienteController";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import { notify } from "../../utils/notify";
import Loading from "../../components/basics/Loading";
import MaskService from "../../utils/mask/maskService";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "cpfcnpj",
    label: "N° Inscrição",
  },
  {
    id: "apelido",
    label: "Nome",
  },
  { id: "ccm", label: "CCM" },
];

export default function ListagemCliente() {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [statusActive, setStatusActive] = useState(true);
  const { queryParams } = useContext(QueryParamsContext);
  const { handleOpenInsert, handleClearContext } = useClienteController();
  const { push } = useHistory();

  useEffect(() => {
    handleClearContext();
  }, [handleClearContext]);

  useEffect(() => {
    setData(
      allData.filter((item) => (statusActive ? item.ativo !== "N" : true))
    );
  }, [statusActive, allData]);

  useEffect(() => {
    const handleEdit = (row = {}) => {
      push({
        pathname: "edicao",
        state: JSON.stringify(row),
      });
    };

    const handleChangeStatus = async (item, ativo) => {
      try {
        setLoading(true);
        const resultApi = await updateCliente(
          item.id,
          queryParams.empresa_cnpj,
          { cliente: { ativo } }
        );

        if (resultApi && resultApi.success) {
          return setRefresh(!refresh);
        }

        notify("Não foi possível alterar o status.");
      } catch (error) {
        notify("Não foi possível alterar o status.");
        console.error("ERROR ListagemCliente handleChangeStatus", error);
      } finally {
        setLoading(false);
      }
    };

    const getData = async () => {
      try {
        setLoadingData(true);
        const result = await findCliente(queryParams.empresa_cnpj, 100000);

        if (result.success) {
          result.data.forEach((item) => {
            if (item.cpfcnpj && typeof item.cpfcnpj === "string") {
              item.cpfcnpj = item.cpfcnpj.replace(/[^0-9]+/g, "");

              item.cpfcnpj = MaskService.toMask(
                item.cpfcnpj.length < 12 ? "cpf" : "cnpj",
                item.cpfcnpj
              );
            } else item.cpfcnpj = "";

            item.acoes = (
              <Grid container alignItems="center" justify="center">
                <Grid item>
                  <Tooltip title="Editar">
                    <img
                      src="/icons/edit.svg"
                      alt="Editar"
                      className="icon-edit-svg"
                      onClick={() => handleEdit(item)}
                    />
                  </Tooltip>
                </Grid>

                <Grid item>
                  {item.ativo === "N" ? (
                    <Tooltip title="Ativar">
                      <HighlightOff
                        className="icon-active"
                        onClick={() => handleChangeStatus(item, "S")}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Inativar">
                      <CheckCircleOutline
                        className="icon-inactive"
                        onClick={() => handleChangeStatus(item, "N")}
                      />
                    </Tooltip>
                  )}
                </Grid>
              </Grid>
            );
          });

          setData(result.data);
          setAllData(result.data);
        }
      } catch (error) {
        console.error("ERROR findCliente ListagemCliente", error);
      } finally {
        setLoadingData(false);
      }
    };

    getData();
  }, [refresh, push, queryParams.empresa_cnpj]);

  const handleChangeFilter = (e) => {
    if (!e) return setData(allData);

    const text = e.target.value
      .normalize("NFD")
      .toLowerCase()
      .replace(/[^a-z0-9_]/g, "");

    let copyData = [...allData];

    copyData = copyData.filter(
      (customer) =>
        (customer.apelido
          ? customer.apelido
              .normalize("NFD")
              .toLowerCase()
              .replace(/[^a-z0-9_]/g, "")
              .includes(text)
          : false) ||
        (customer.cpfcnpj
          ? customer.cpfcnpj
              .normalize("NFD")
              .toLowerCase()
              .replace(/[^a-z0-9_]/g, "")
              .includes(text)
          : false)
    );

    setData(copyData);
  };

  return (
    <>
      <Loading open={loading} />
      <TableDefault
        loading={loadingData}
        columns={columns}
        tableTitle={
          <>
            <Grid
              container
              alignItems="center"
              spacing={2}
              justify="space-between"
              style={{ padding: 10, marginTop: 5 }}
            >
              <Grid
                item
                container
                justify="flex-start"
                lg={6}
                md={8}
                sm={9}
                xs={9}
              >
                Listagem dos clientes
              </Grid>

              <Grid
                item
                container
                justify="flex-end"
                lg={6}
                md={4}
                sm={3}
                xs={3}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenInsert}
                >
                  <Add />
                  Inserir
                </Button>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              justify="flex-start"
              style={{ marginBottom: 15 }}
            >
              <Grid item lg={5} md={8} sm={12} xs={11}>
                <SearchInput handleChange={handleChangeFilter} />
              </Grid>

              <Grid
                item
                lg={7}
                md={4}
                sm={12}
                xs={12}
                container
                justify="flex-end"
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={statusActive}
                      onChange={() => setStatusActive((current) => !current)}
                      name="checkedB"
                    />
                  }
                  label="Apenas ativos"
                />
              </Grid>
            </Grid>
          </>
        }
        values={data}
      />
    </>
  );
}
